import React from 'react';
import { getUniqueCities, getUniqueLodges, getMeetingTypes } from '../meetingData';

const FilterControls = ({ filters, onFilterChange, meetingCount }) => {
  const cities = getUniqueCities();
  const lodges = getUniqueLodges();
  const meetingTypes = getMeetingTypes();

  const handleTypeChange = (type) => {
    const newTypes = filters.types.includes(type)
      ? filters.types.filter(t => t !== type)
      : [...filters.types, type];
    onFilterChange({ ...filters, types: newTypes });
  };

  const clearAllFilters = () => {
    onFilterChange({
      types: [],
      city: '',
      lodge: '',
      dresscode: '',
      search: '',
      storloge: false,
      igld: false,
      showSamain: true,
      bardaland: true,
      jarnbaraland: false,
      folkungaland: false
    });
  };

  const hasActiveFilters = () => {
    return filters.types.length > 0 || 
           filters.city || 
           filters.lodge || 
           filters.dresscode ||
           filters.search ||
           filters.storloge ||
           filters.igld ||
           !filters.showSamain ||
           !filters.bardaland ||
           filters.jarnbaraland ||
           filters.folkungaland;
  };

  return (
    <div className="filter-controls">
      <div className="filter-header">
        <h3>Filtrera möten</h3>
        <div className="meeting-count">
          {meetingCount} möten
        </div>
      </div>

      {/* Search */}
      <div className="filter-group">
        <label>Sök i detaljer:</label>
        <input
          type="text"
          placeholder="Sök efter kräfta, reception, etc..."
          value={filters.search}
          onChange={(e) => onFilterChange({ ...filters, search: e.target.value })}
          className="search-input"
        />
      </div>

      {/* Meeting Types */}
      <div className="filter-group">
        <label>Mötestyp:</label>
        <div className="checkbox-group">
          {meetingTypes.map(type => (
            <label key={type} className="checkbox-label">
              <input
                type="checkbox"
                checked={filters.types.includes(type)}
                onChange={() => handleTypeChange(type)}
              />
              <span className="checkbox-text">{type}</span>
            </label>
          ))}
        </div>
      </div>

      {/* City Filter */}
      <div className="filter-group">
        <label>Stad:</label>
        <select
          value={filters.city}
          onChange={(e) => onFilterChange({ ...filters, city: e.target.value })}
          className="filter-select"
        >
          <option value="">Alla städer</option>
          {cities.map(city => (
            <option key={city} value={city}>{city}</option>
          ))}
        </select>
      </div>

      {/* Lodge Filter */}
      <div className="filter-group">
        <label>Loge:</label>
        <select
          value={filters.lodge}
          onChange={(e) => onFilterChange({ ...filters, lodge: e.target.value })}
          className="filter-select"
        >
          <option value="">Alla loger</option>
          {lodges.map(lodge => (
            <option key={lodge} value={lodge}>{lodge}</option>
          ))}
        </select>
      </div>

      {/* Dress Code Filter */}
      <div className="filter-group">
        <label>Klädsel:</label>
        <select
          value={filters.dresscode}
          onChange={(e) => onFilterChange({ ...filters, dresscode: e.target.value })}
          className="filter-select"
        >
          <option value="">Alla</option>
          <option value="Frack">Frack</option>
          <option value="Vårdad">Vårdad</option>
          <option value="Casual">Casual/Övrigt</option>
        </select>
      </div>

      {/* Regions */}
      <div className="filter-group">
        <label>Regioner:</label>
        <div className="checkbox-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={filters.bardaland || false}
              onChange={(e) => onFilterChange({ ...filters, bardaland: e.target.checked })}
            />
            <span className="checkbox-text">Bardaland</span>
          </label>
          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={filters.jarnbaraland || false}
              onChange={(e) => onFilterChange({ ...filters, jarnbaraland: e.target.checked })}
            />
            <span className="checkbox-text">Järnbäraland</span>
          </label>
          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={filters.folkungaland || false}
              onChange={(e) => onFilterChange({ ...filters, folkungaland: e.target.checked })}
            />
            <span className="checkbox-text">Folkungaland</span>
          </label>
        </div>
      </div>

      {/* Special Meetings */}
      <div className="filter-group">
        <label>Specialmöten:</label>
        <div className="checkbox-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={filters.showSamain || false}
              onChange={(e) => onFilterChange({ ...filters, showSamain: e.target.checked })}
            />
            <span className="checkbox-text">Visa Samain möten</span>
          </label>
          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={filters.storloge || false}
              onChange={(e) => onFilterChange({ ...filters, storloge: e.target.checked })}
            />
            <span className="checkbox-text">Storloge-möten</span>
          </label>
          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={filters.igld || false}
              onChange={(e) => onFilterChange({ ...filters, igld: e.target.checked })}
            />
            <span className="checkbox-text">IGLD-möten</span>
          </label>
        </div>
      </div>

      {/* Clear Filters */}
      {hasActiveFilters() && (
        <div className="filter-actions">
          <button onClick={clearAllFilters} className="clear-filters-btn">
            Rensa alla filter
          </button>
        </div>
      )}
    </div>
  );
};

export default FilterControls;